import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock } from 'lucide-react';
export function ROICalculator() {
  const [hiresPerMonth, setHiresPerMonth] = useState(5);
  const timeSaved = hiresPerMonth * 12;
  return <section className="py-16 md:py-24 bg-gradient-to-br from-slate-50 to-blue-50" data-id="element-65">
      <div className="max-w-3xl mx-auto px-6" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-67">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4" data-id="element-68">
            <Clock className="w-4 h-4" data-id="element-69" />
            ROI Calculator
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-70">
            See How Much Time You'll Save
          </h2>
          <p className="text-lg text-slate-600" data-id="element-71">
            AI-powered screening saves an average of 12 hours per hire
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-slate-100" data-id="element-72">
          {/* Slider Section */}
          <div className="mb-12" data-id="element-73">
            <label className="block text-center mb-6" data-id="element-74">
              <span className="text-lg font-semibold text-slate-700 block mb-2" data-id="element-75">
                Hires per Month
              </span>
              <span className="text-4xl font-bold text-blue-600" data-id="element-76">
                {hiresPerMonth}
              </span>
            </label>

            <input type="range" min="1" max="20" value={hiresPerMonth} onChange={e => setHiresPerMonth(Number(e.target.value))} className="w-full h-3 bg-slate-200 rounded-lg appearance-none cursor-pointer slider" style={{
            background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${(hiresPerMonth - 1) / 19 * 100}%, #e2e8f0 ${(hiresPerMonth - 1) / 19 * 100}%, #e2e8f0 100%)`
          }} data-id="element-77" />

            <div className="flex justify-between text-sm text-slate-500 mt-2" data-id="element-78">
              <span data-id="element-79">1</span>
              <span data-id="element-80">20</span>
            </div>
          </div>

          {/* Result Display */}
          <div className="text-center py-8 border-t border-slate-100" data-id="element-81">
            <p className="text-slate-600 text-lg mb-4 font-medium" data-id="element-82">
              Time Saved Each Month
            </p>
            <AnimatePresence mode="wait" data-id="element-83">
              <motion.div key={timeSaved} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.2
            }} className="text-6xl md:text-7xl font-extrabold text-green-600 mb-2" data-id="element-84">
                {timeSaved}
              </motion.div>
            </AnimatePresence>
            <p className="text-2xl font-semibold text-slate-700" data-id="element-85">Hours</p>

            {timeSaved >= 40 && <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} className="mt-6 text-slate-600 bg-green-50 border border-green-200 rounded-lg px-4 py-3 inline-block" data-id="element-86">
                That's over{' '}
                <span className="font-bold text-green-700" data-id="element-87">
                  {Math.floor(timeSaved / 8)} full work days
                </span>{' '}
                saved!
              </motion.p>}
          </div>
        </motion.div>

        <p className="text-center text-sm text-slate-500 mt-6" data-id="element-88">
          Based on industry average of 12 hours per hire for manual resume
          screening and initial interviews
        </p>
      </div>
    </section>;
}